import { useEffect } from 'react';
import { renderEmbeds } from '~/domain/plugins/services/cookie-consent';

/**
 * @param enabled Whether cookie consent is configured for this environment.
 *   Must be a server-deterministic value (see `isCookieConsentEnabled`) — do
 *   NOT derive it from `window`, or the server and client will render a
 *   different tree and break hydration. `renderEmbeds()` safely no-ops if the
 *   CookieFirst script hasn't loaded yet.
 */
export function CookieDeclaration({ enabled }: { enabled: boolean }) {
  useEffect(() => {
    renderEmbeds();
  }, []);

  return enabled ? <div id="cookiefirst-cookies-table" /> : null;
}
